{
  "buttons/add.Label": "Hinzufügen",
  "buttons/cancel.Label": "Abbrechen",
  "buttons/delete.Label": "Löschen",
  "buttons/create.Label": "Erstellen",
  "buttons/save.Label": "Speichern",
  "buttons/search.Label": "Suche",
  "buttons/continue.Label": "Weiter",
  "buttons/send.Label": "Senden",
  "buttons/close.Label": "Schließen",
  "buttons/back.Label": "Zurück",
  "labels/search.Label": "Suchen",
  "labels/pagination/showResults.Label": "Resultate anzeigen",
  "input/search.Placeholder": "Suchen Sie nach Ihrer Phrase",

  "titles/create-new.Label": "Neu erstellen",
  "titles/edit.Label": "Bearbeiten",
  "titles/image.Placeholder":  "Bild hinzufügen",
  "labels/tables.Loading": "Ergebnisse laden...",
  "labels/tables.NoResults": "Keine Ergebnisse",
  "labels/tables.MoreNoResults": "Es gibt keine Daten zur Vorschau.",
  "labels/tables.ChangePhrase": "Bitte ändern Sie den Suchbegriff.",
  "labels/tables.ResetFilters": "filter zurücksetzen",

  "forms/required.Label": "Pflichtfeld"
}
